// extracted by mini-css-extract-plugin
export default {"form":"SelectCompany_form__3Wp0Z","header":"SelectCompany_header__R5PRK","input":"SelectCompany_input__-HIUG"};